import { sanitizeData } from "../../util/DataSanitizerUtil";
import { SupplierLocationDisplayVO, deriveLocationStatus } from "../../types/LocationStatus";
import { SupplierLocationListingVO } from "../../types/model/valueObject/location/SupplierLocationListingVO";

/**
 * Maps one `GET /api/locations` row to the card display model: sanitizes it and derives the tab status.
 *
 * `sanitizeData` turns every falsy number into `null`, so a numeric field where `0` is meaningful is
 * restored from the raw response. Numbers carry no markup, so this doesn't weaken XSS protection.
 */
export const toSupplierLocationDisplayVO = (loc: SupplierLocationListingVO): SupplierLocationDisplayVO => ({
  ...(sanitizeData(loc as any) as unknown as SupplierLocationListingVO),
  // A schedule block can hand over to a 0-space (closed) day; "Then 0 spaces" must survive.
  capacityAfterScheduleEnds: typeof loc.capacityAfterScheduleEnds === "number" ? loc.capacityAfterScheduleEnds : null,
  capacityUtilizationPercent: typeof loc.capacityUtilizationPercent === "number" ? loc.capacityUtilizationPercent : null,
  derivedStatus: deriveLocationStatus(loc as { status: string; live: boolean }),
});
